import React, {
  useContext,
  useCallback,
  ReactNode,
  useState,
  useEffect,
} from "react";
import { apolloLink, cache } from "@/api/apolloClient";
import {
  ApolloClient,
  NormalizedCacheObject,
  ApolloProvider,
} from "@apollo/client";
import { AuthContext } from "./AuthProvider";
import { organizationsVar } from "@/reactiveVars/user";
import { PageLoader } from "@/components/PageLoader";

export const ApolloProviderWrapper = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [client, setClient] = useState<
    ApolloClient<NormalizedCacheObject> | undefined
  >();
  const { addLogoutListener } = useContext(AuthContext);

  const clearApolloCache = useCallback(() => {
    client?.clearStore();
    // clear any user specific reactive variables
    organizationsVar.clear(null);
  }, [client]);

  useEffect(() => {
    async function init() {
      setClient(
        new ApolloClient({
          link: apolloLink,
          cache,
        }),
      );
    }

    init().catch(console.error);
  }, []);

  useEffect(() => {
    addLogoutListener(clearApolloCache);
  }, [addLogoutListener, clearApolloCache]);

  if (!client) return <PageLoader />;

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};
